/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { object, array } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SkeletonStyles from './SkeletonStyles';

const styles = (theme) => ({
    // Import Skeleton layout
    ...SkeletonStyles,
    // Page Elements
    root: {
        display: 'flex',
        width: '384px',
        marginTop: '5px',
        '@media screen and (max-width: 384px)': {
            minWidth: '360px',
            paddingLeft: '10px',
        },
    },
    textBody: {
        width: '92%',
        height: '60px',
    },
});

const PriceShownSkeleton = ({ classes }) => (
    <div className={classes.root}>
        <div className={`${classes.textLG} ${classes.textBody}`} />
    </div>
);
PriceShownSkeleton.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(PriceShownSkeleton);
